// Regular pentagon: all 5 sides equal (circumradius=8.5, center=10,9.5)
// Vertices: top → clockwise. Side length ≈ 10px at this scale.
// viewBox 20×19 — height matches 1em (the parent font size)

export default function VerifiedBadge() {
  return (
    <svg
      viewBox="0 0 20 19"
      style={{ height: "1em", width: "auto", verticalAlign: "middle", flexShrink: 0, display: "inline-block" }}
      fill="none"
      title="Verified by PadhaiPass"
    >
      {/* Regular pentagon, all sides equal */}
      <polygon
        points="10,1 18.1,6.9 15,16.4 5,16.4 1.9,6.9"
        fill="#f59e0b"
        stroke="#fde68a"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      {/* White checkmark centered inside */}
      <path
        d="M6.5 9.8l2.8 3 4.2-5.2"
        stroke="#ffffff"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
